import * as React from "react";
import { SVGProps } from "react";
export const CalendarPencilFillIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M4.16667 18.3334C3.70833 18.3334 3.31597 18.1702 2.98958 17.8438C2.66319 17.5174 2.5 17.1251 2.5 16.6667V5.00008C2.5 4.54175 2.66319 4.14939 2.98958 3.823C3.31597 3.49661 3.70833 3.33341 4.16667 3.33341H5V1.66675H6.66667V3.33341H13.3333V1.66675H15V3.33341H15.8333C16.2917 3.33341 16.684 3.49661 17.0104 3.823C17.3368 4.14939 17.5 4.54175 17.5 5.00008V9.16675H15.8333V8.33341H4.16667V16.6667H10V18.3334H4.16667ZM11.6667 18.3334V15.7709L16.2708 11.1876C16.3958 11.0626 16.5347 10.9723 16.6875 10.9167C16.8403 10.8612 16.9931 10.8334 17.1458 10.8334C17.3125 10.8334 17.4722 10.8647 17.625 10.9272C17.7778 10.9897 17.9167 11.0834 18.0417 11.2084L18.8125 11.9792C18.9236 12.1042 19.0104 12.2431 19.0729 12.3959C19.1354 12.5487 19.1667 12.7015 19.1667 12.8542C19.1667 13.007 19.1389 13.1633 19.0833 13.323C19.0278 13.4827 18.9375 13.6251 18.8125 13.7501L14.2292 18.3334H11.6667ZM17.1458 13.6667L17.9167 12.8542L17.1458 12.0834L16.3542 12.8751L17.1458 13.6667Z"
            fill="currentColor"
        />
    </svg>
);
CalendarPencilFillIcon.displayName = "CalendarPencilFillIcon";
